import { get, post, put, del } from '../request'

/**
 * 菜单管理相关API
 */

/**
 * 获取菜单列表
 * @param {Object} params 筛选参数
 * @param {number} params.page 页码
 * @param {number} params.limit 每页数量
 * @param {string} params.menuName 菜单名称
 * @param {number} params.status 启用状态 1-启用 2-禁用
 * @param {number} params.isShow 显示状态 1-显示 0-隐藏
 * @returns {Promise} 菜单列表数据
 */
export function getMenuList(params = {}) {
  return get('/ums/menu', params)
}

/**
 * 获取菜单树形数据
 * @param {Object} params 筛选参数
 * @param {string} params.menuName 菜单名称
 * @param {number} params.status 启用状态 1-启用 2-禁用
 * @param {number} params.isShow 显示状态 1-显示 0-隐藏
 * @returns {Promise} 菜单树形数据
 */
export function getMenuTree(params = {}) {
  return get('/ums/menu/tree', params)
}

/**
 * 添加菜单
 * @param {Object} data - 菜单数据
 * @returns {Promise} 返回添加结果
 */
export function addMenu(data) {
  return post('/ums/menu', data)
}

/**
 * 更新菜单
 * @param {number} id - 菜单ID
 * @param {Object} data - 菜单数据
 * @returns {Promise} 返回更新结果
 */
export function updateMenu(id, data) {
  return put(`/ums/menu/${id}`, data)
}

/**
 * 删除菜单
 * @param {number} id - 菜单ID
 * @returns {Promise} 返回删除结果
 */
export function deleteMenu(id) {
  return del(`/ums/menu/${id}`)
}

/**
 * 获取菜单详情
 * @param {number} id - 菜单ID
 * @returns {Promise} 返回菜单详情
 */
export function getMenuDetail(id) {
  return get(`/ums/menu/${id}`)
}

/**
 * 获取当前用户的菜单权限
 * @returns {Promise} 返回用户有权限的菜单列表
 */
export function getUserMenus() {
  return get('/ums/menu/user/menus')
}

/**
 * 获取当前用户的菜单权限（树形结构）
 * @returns {Promise} 返回用户有权限的菜单树形数据
 */
export function getUserMenuTree() {
  return get('/ums/menu/user/tree')
}

/**
 * 获取当前用户的权限资源数据（用于动态菜单生成）
 * @returns {Promise} 返回用户有权限的资源数据，包含完整的菜单结构信息
 */
export function getUserPermissionResources() {
  return get('/ums/admin/permission-resource')
}